import { render, staticRenderFns } from "./parques.vue?vue&type=template&id=37cd7d5e&scoped=true&"
import script from "./parques.vue?vue&type=script&lang=js&"
export * from "./parques.vue?vue&type=script&lang=js&"
import style0 from "./parques.vue?vue&type=style&index=0&id=37cd7d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd7d5e",
  null
  
)

export default component.exports